<script>
export default {
  name: "SpeakingSkill",
  props:{
    data: {
      type: Object,
      default: null
    }
  },
  data(){
    return{
      currentIndex: 0
    }
  },
  computed:{
    currentAudio(){
      if(!this.data?.questions || this.data?.questions.length === 0 ){
        return  ''
      }
      return this.data?.questions[this.currentIndex]?.answer
    },
    currentQuestion(){
      if(!this.data?.questions || this.data?.questions.length === 0 ){
        return  ''
      }
      return this.data?.questions[this.currentIndex]?.content
    }
  },
  methods:{
    changeQuestion(questionIndex){
      this.currentIndex = questionIndex
      this.$nextTick(() => {
        const audio = this.$refs.audioPlayer
        if (audio) {
          audio.pause()
          audio.currentTime = 0
          audio.load()
          audio.play().catch(err => {
            console.warn('Auto-play failed:', err)
          })
        }
      })
    }
  }
}
</script>

<template>
  <div >
    <div style="background-color: #F8F8F8" class="p-5" v-if="data">
      <p style="font-weight: bold">Kĩ năng: Nói</p>
      <div class="step-container">
        <div v-for="(question,questionIndex) in data?.questions" :key="question?.id" :class="currentIndex === questionIndex? 'step-active':'step-circle'" @click="changeQuestion(questionIndex)">{{questionIndex + 1}}</div>
      </div>
      <p class="mt-5" v-html="currentQuestion"></p>
      <p class="mt-5 " style="font-weight: bold ; font-size: 15px">Câu trả lời của học viên</p>
      <audio ref="audioPlayer" controls class="mt-5 " autoplay>
        <source :src="currentAudio" type="audio/ogg">
        <source :src="currentAudio" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
    </div>
    <div v-else>
      <p style="font-weight: bold">Chưa có dữ liệu bài thi nói</p>
    </div>
  </div>

</template>

<style scoped>
.step-circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  line-height: 35px;
  font-weight: bold;
  margin: 0 4px;
  background-color: #dcdcdc; /* xám nhạt */
  color: #000;
  cursor: pointer;
}

.step-active {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  line-height: 35px;
  font-weight: bold;
  margin: 0 4px;
  cursor: pointer;
  background-color: #007bff !important; /* xanh dương */
  color: #fff !important;
}

.step-container {
  display: inline-flex;
  overflow-x: auto;
}
</style>